import service from '../api/client.service';
//constants
const data = {
    findClients: [],
    clients: [],
    clientsSAP: [],
    responseClient: null,
    errorClient: '',
    totalRows: 0,
    loadingUpdate: false
}
//types
const FIND_CLIENT = 'LIST_CLIENT';
const LIST_CLIENT = 'LIST_CLIENT';
const LIST_CLIENT_SAP = 'LIST_CLIENT_SAP';
const CLIENT_ERROR = 'CLIENT_ERROR';
const CLIENT_COUNT = 'CLIENT_COUNT';
const CLIENT_UPDATE_STATE = 'CLIENT_UPDATE_STATE';
const CLIENT_UPDATE_STATE_INIT = 'CLIENT_UPDATE_STATE_INIT';

//reducer
export default function clientReducer(state = data, action) {
    switch (action.type) {
        case FIND_CLIENT:
            return { ...state, findClients: action.payload };
        case LIST_CLIENT:
            return { ...state, clients: action.payload };
        case LIST_CLIENT_SAP:
            return { ...state, clientsSAP: action.payload };
        case CLIENT_ERROR:
            return { ...state, errorClient: action.payload };
        case CLIENT_COUNT:
            return { ...state, totalRows: action.payload };
        case CLIENT_UPDATE_STATE:
            return { ...state, loadingUpdate: false, responseClient: action.payload };
        case CLIENT_UPDATE_STATE_INIT:
            return { ...state, loadingUpdate: true, responseClient: null };
        default:
            return { ...state };
    }
}

// Despacha la lista de clientes como opciones { value, label } (o el error) y la devuelve
const dispatchClientOptions = (dispatch, response) => {
    const data = [];
    if (response.code !== undefined) {
        dispatch({
            type: CLIENT_ERROR,
            payload: response
        });
        dispatch({
            type: LIST_CLIENT,
            payload: []
        });
    } else {
        response.forEach((element) => {
            data.push({
                value: element.code,
                label: element.name.toUpperCase()
            });
        });
        dispatch({
            type: CLIENT_ERROR,
            payload: ''
        });
        dispatch({
            type: LIST_CLIENT,
            payload: data
        });
    }
    return data;
}

export const findClientBy = (json) => async (dispatch) => {

    const response = await service.findClientsBy(json).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    return dispatchClientOptions(dispatch, response);
}

export const findClient = (filter) => async (dispatch) => {

    const response = await service.findClients(20, filter).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    dispatchClientOptions(dispatch, response);
}

export const findClientBySociety = (filter, society) => async (dispatch) => {

    const response = await service.findClientsBySociety(20, filter, society).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });

    if (response.code !== undefined) {
        dispatch({
            type: CLIENT_ERROR,
            payload: response
        });
        dispatch({
            type: LIST_CLIENT,
            payload: []
        });
    } else {

        response.forEach((element) => {
            element.value = element.clientCode;
            element.label = element.clientCode + ' | ' + element.clientName;

        });
        dispatch({
            type: CLIENT_ERROR,
            payload: ''
        });
        dispatch({
            type: LIST_CLIENT,
            payload: response
        });
    }
    return response
}

export const findWithPageByFilter = (request) => async (dispatch) => {

    const response = await service.findWithPageByFilter(request).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: CLIENT_ERROR,
            payload: response
        });
        dispatch({
            type: LIST_CLIENT_SAP,
            payload: []
        });
    } else {
        dispatch({
            type: CLIENT_ERROR,
            payload: ''
        });
        dispatch({
            type: LIST_CLIENT_SAP,
            payload: response
        });
    }

}
export const countPageByFilter = (request) => async (dispatch) => {

    const response = await service.countPageByFilter(request).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: CLIENT_ERROR,
            payload: response
        });
        dispatch({
            type: CLIENT_COUNT,
            payload: 0
        });
    } else {

        dispatch({
            type: CLIENT_ERROR,
            payload: ''
        });
        dispatch({
            type: CLIENT_COUNT,
            payload: response
        });
    }

}
export const updateStateInit = (username, customer) => async (dispatch) => {
    
    dispatch({
        type: CLIENT_UPDATE_STATE_INIT,
        payload: ''
    });
  
}

export const customerUpdateState = (username, customer) => async (dispatch) => {
    dispatch({
        type: CLIENT_UPDATE_STATE_INIT,
        payload: ''
    });
    const response = await service.updateState(username, customer).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: CLIENT_ERROR,
            payload: response
        });
        dispatch({
            type: CLIENT_UPDATE_STATE,
            payload: ''
        });
    } else {

        dispatch({
            type: CLIENT_ERROR,
            payload: ''
        });
        dispatch({
            type: CLIENT_UPDATE_STATE,
            payload: response
        });
    }
}